export default "__VITE_ASSET__CKdkTo5Y__"